import { Controller, useFormContext } from "react-hook-form";

import type { SelectProps } from "@luna-restaurant/ui";
import { Select } from "@luna-restaurant/ui";

export type FormSelectProps<V = string> = {
  name: string;
} & Omit<SelectProps<V>, "value" | "onChange">;

export function FormSelect<V = string>({
  name,
  ...inputProps
}: FormSelectProps<V>) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, onBlur, value }, fieldState }) => (
        <Select<V>
          value={value}
          onChange={(value) => {
            onChange(value);
            onBlur();
          }}
          error={fieldState.error?.message ?? false}
          {...inputProps}
        />
      )}
    />
  );
}
